import {
  FormField,
  type FormFieldProps,
  Row,
  Switch,
  type SwitchProps,
  Tooltip,
} from "@hightouch/htui";

export type Props = Omit<
  FormFieldProps & SwitchProps,
  "children" | "aria-label" | "label"
> & {
  label: string;
  isLoading?: boolean;
  switchTooltip?: string;
};

export const SwitchFormField = ({
  label,
  description,
  isLoading,
  rightContent,
  switchTooltip,
  ...props
}: Props) => {
  return (
    <Row gap={4} align="center">
      <Row justify="space-between" align="center" gap={4} flex={1}>
        <FormField label={label} description={description}>
          {null}
        </FormField>
        {switchTooltip ? (
          <Tooltip message={switchTooltip}>
            <Switch {...props} aria-label={label} />
          </Tooltip>
        ) : (
          <Switch {...props} aria-label={label} />
        )}
      </Row>
      {rightContent}
    </Row>
  );
};
